var _defs, _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrades(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 114.79 114.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#11ccea;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 57.39,
    cy: 57.39,
    r: 57.39
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.65,402.85c-.93-.16-1.86-.29-2.78-.49a18.61,18.61,0,1,1,22.46-21c.08.51.17,1,.25,1.53v2.58a4.54,4.54,0,0,0-.12.5,18.49,18.49,0,0,1-13.81,16.19c-1.11.3-2.27.44-3.41.65ZM278,388.49l-.59-.56-5-5a2.06,2.06,0,0,0-3.18-.13,2,2,0,0,0,.13,3.17l6.72,6.72a2.26,2.26,0,0,0,3.56,0l6.95-6.95c1.71-1.71,3.42-3.4,5.12-5.12a2.13,2.13,0,1,0-3.1-2.92l-10.15,10.15C278.3,388,278.17,388.25,278,388.49Z",
    transform: "translate(-202.59 -312.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M282,361.55c-1.48,0-2.91-.1-4.31,0a22.11,22.11,0,0,0-10.37,3.67,2.24,2.24,0,0,1-1.06.33H240.63v4.13h21.72c-.22.3-.37.47-.49.66-.62.93-1.28,1.84-1.82,2.82a1.17,1.17,0,0,1-1.2.68c-5.83,0-11.65,0-17.47,0h-.74V378h17.31l-.76,4.1H240.65v4.17h16.48c.31,1.45.53,2.85.92,4.21s.94,2.67,1.44,4l-.51,0H237a4.34,4.34,0,0,1-4.64-4.65V341.25a4.34,4.34,0,0,1,4.6-4.63q14,0,27.88,0a1.57,1.57,0,0,1,1,.4q7.88,7.83,15.71,15.67a1.41,1.41,0,0,1,.47,1.13c0,2.33,0,4.66,0,7Zm-8.27-4.21H240.65v4.08h33.08Zm-8.26-16.51c0,.2,0,.34,0,.49,0,2.82,0,5.65,0,8.47a3.26,3.26,0,0,0,3.38,3.39h8.47c.16,0,.32,0,.47-.05Z",
    transform: "translate(-202.59 -312.7)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrades);
export default __webpack_public_path__ + "static/media/grades.f06def56054a4f11f129944e8b76fe0b.svg";
export { ForwardRef as ReactComponent };